import React from 'react';
import Loader from './loader';

interface IButtonProps {
  icon?: React.ReactElement | null;
  disabled?: boolean;
  loading?: boolean;
  children?: React.ReactElement;
  clicked?: () => void;
  label: string;
  extraClass?: string;
  type?: string;
  submitType?: 'submit' | 'button';
  fullWidth?: boolean;
  size?: 'default' | 'sm' | 'md' | 'lg';
}

const AppButton = ({
  type = 'primary',
  submitType = 'button',
  fullWidth = true, // Default to true
  size = 'default',
  ...props
}: IButtonProps) => {
  const typeClasses = () => {
    if (props.disabled) {
      return 'bg-gray-100 text-gray-500 cursor-not-allowed';
    } else if (type === 'primary') {
      return 'bg-primary text-white';
    } else if (type === 'dark') {
      return 'text-white bg-gray-950';
    } else if (type === 'light') {
      return 'bg-transparent border border-gray-950 text-gray-950';
    } else if (type === 'gray') {
      return 'bg-gray-100 hover:bg-gray-200';
    } else if (type === 'danger') {
      return 'bg-[#FFF7F6] text-[#F75028] hover:bg-red-100 transition';
    } else if (type === 'danger-light') {
      return 'border border-red-600 text-red-600 transition';
    } else if (type === 'error') {
      return 'bg-[#FFEDEC] border border-[#FFEDEC] text-[#E03137] ';
    } else return '';
  };

  const loaderClasses = () => {
    if (type === 'primary' || type === 'dark') {
      return 'border-t-white';
    } else if (type === 'danger') {
      return 'border-t-[#F75028]';
    } else return 'border-t-white';
  };

  const sizeClasses = () => {
    if (size === 'default') {
      return 'px-10 py-2 h-12';
    } else if (size === 'sm') {
      return 'px-6 py-2 h-12';
    } else if (size === 'md') {
      return 'px-6 py-2 h-[2.6rem]';
    } else if (size === 'lg') {
      return 'px-8 py-2 h-12';
    }
  };

  return (
    <button
      type={submitType}
      onClick={props.clicked}
      disabled={props.loading || props.disabled}
      className={`rounded-xl text-sm font-medium transition-colors duration-200 cursor-pointer flex items-center justify-center space-x-2 ${
        fullWidth ? 'w-full' : 'w-fit'
      } ${props.extraClass} ${typeClasses()} ${sizeClasses()}`}
    >
      {props.icon && !props.loading && props.icon}
      {props.loading ? (
        <span className="flex items-center">
          <Loader width="1.5rem" borderTopColor={loaderClasses()} />
        </span>
      ) : (
        <span>{props.label}</span>
      )}
    </button>
  );
};

export default AppButton;
